import React from "react";

const CheckMarkFilled = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            fill={fill}
            d="M28.133 2a5.868 5.868 0 0 1 5.859 5.555l.008.312v20.266a5.868 5.868 0 0 1-5.555 5.859l-.312.008H7.867a5.867 5.867 0 0 1-5.859-5.555L2 28.133V7.867a5.868 5.868 0 0 1 5.555-5.859L7.867 2h20.266ZM23.93 13.669a1.6 1.6 0 0 0-2.262 0L16.4 18.936l-2.069-2.067-.15-.133a1.6 1.6 0 0 0-2.112 2.395l3.2 3.2.15.133a1.6 1.6 0 0 0 2.112-.133l6.4-6.4.133-.15a1.6 1.6 0 0 0-.133-2.112Z"
        />
    </svg>
);

export default CheckMarkFilled;